import { supabase } from "../lib/supabase";

function getSupabasePublicConfig(): { url: string; anon: string } {
  const url =
    (typeof process !== "undefined" && process.env.VITE_SUPABASE_URL) ||
    import.meta.env?.VITE_SUPABASE_URL ||
    "";
  const anon =
    (typeof process !== "undefined" && process.env.VITE_SUPABASE_ANON_KEY) ||
    import.meta.env?.VITE_SUPABASE_ANON_KEY ||
    "";
  return { url, anon };
}

/**
 * Download a booking-scoped storage object via Edge Function (service-role storage),
 * avoiding hosted Storage HTTP bugs for keys that start with a company UUID.
 */
export async function fetchBookingStorageBlobViaEdge(params: {
  bucket: string;
  objectPath: string;
  bookingId: number;
}): Promise<Blob> {
  const { url, anon } = getSupabasePublicConfig();
  if (!url || !anon) {
    throw new Error("Missing Supabase configuration");
  }

  const { data: sessionData } = await supabase.auth.getSession();
  const token = sessionData.session?.access_token;
  if (!token) {
    throw new Error("Not authenticated");
  }

  const base = url.replace(/\/$/, "");
  const res = await fetch(
    `${base}/functions/v1/download-booking-storage-file`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        apikey: anon,
      },
      body: JSON.stringify(params),
    },
  );

  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try {
      const j: { error?: string } = await res.json();
      if (j?.error) msg = j.error;
    } catch {
      const t = await res.text();
      if (t) msg = t;
    }
    throw new Error(msg);
  }

  return await res.blob();
}
